import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { PaginatedResponse } from "../../../core/http/paginated-response.type";
import { QueryParams } from "../../../core/http/query-params.type";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { DEFAULT_QUERY_PARAMS } from "../../../shared/constants/services";
import { AnyObject } from "../../../shared/types/app.type";
import { UserInfo } from "../../../shared/types/user-info";
import { ConfigurableOption } from "./configurable-options.type";

@Injectable({
  providedIn: "root",
})
export class ConfigurableOptionService {
  currentUser: UserInfo;
  basePath = `${environment.serverUrl}/configurable-options`;
  basePathCsvQueue = `${this.basePath}/queue-csv`;

  constructor(private readonly http: HttpClient, private readonly authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  getConfigurableOption(id: string): Observable<ConfigurableOption> {
    return this.http.get<ConfigurableOption>(`${this.basePath}/${id}`).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getConfigurableOptions(options?: QueryParams<ConfigurableOption>): Observable<PaginatedResponse<ConfigurableOption>> {
    let params: HttpParams = new HttpParams();
    options = { ...DEFAULT_QUERY_PARAMS, ...options };

    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }

    return this.http.get<PaginatedResponse<ConfigurableOption>>(this.basePath, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  createConfigurableOption(values: AnyObject): Observable<ConfigurableOption> {
    return this.http.post<ConfigurableOption>(`${this.basePath}`, values).pipe(
      tap((_data: ConfigurableOption) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  updateConfigurableOption(id: string, values: AnyObject): Observable<ConfigurableOption> {
    return this.http.put<ConfigurableOption>(`${this.basePath}/${id}`, values).pipe(
      tap((_data: ConfigurableOption) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getSearchableOptions(options?: QueryParams<ConfigurableOption>): Observable<SearchInputOption[]> {
    return this.getConfigurableOptions(options).pipe(
      map((r: PaginatedResponse<ConfigurableOption>) =>
        r.items.map((configurableOption: ConfigurableOption) => ({
          auxValue: configurableOption.id,
          value: configurableOption.value,
          label: configurableOption.value,
        })),
      ),
    );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return throwError(error);
    };
  }
}
